var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-more-page"},[(_vm.nomore)?_c('li',[_vm._v("加载中...")]):_c('li',[_vm._v("没有更多了...")])])}
var staticRenderFns = []

export { render, staticRenderFns }